// //ページトップ

// document.addEventListener("DOMContentLoaded", function () {
//   const pageTopButton = document.querySelector(".js-pageTop");

//   console.log(pageTopButton); // ボタンが正しく取得されているか確認

//   if (!pageTopButton) {
//     console.error("ページトップボタンが見つかりません。");
//     return;
//   }

//   if (pageTopButton) {
//     console.error("あいよ");
//     return;
//   }

//   // スクロールイベントの検知
//   window.addEventListener("scroll", function () {
//     // 200px以上スクロールしたら表示
//     if (window.scrollY > 200) {
//       pageTopButton.style.display = "flex";
//     } else {
//       pageTopButton.style.display = "none";
//     }
//   });

//   // ボタンクリックでトップへスムーズスクロール
//   pageTopButton.addEventListener("click", function () {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth", // スムーズスクロール
//     });
//   });
// });

const topButton = document.querySelector(".js-pageTop");

topButton.addEventListener("click", () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});

window.addEventListener("scroll", () => {
  if (window.scrollY > 300) {
    topButton.style.display = "block";
  } else {
    topButton.style.display = "none";
  }
});
